import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  IconButton,
  Divider,
  Box,
  Button,
} from '@mui/material';
import {
  Close as CloseIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import { Contact } from '../../types/contact';

interface CustomerSearchResultsProps {
  open: boolean;
  onClose: () => void;
  customers: Contact[];
  onSelectCustomer: (customer: Contact) => void;
  searchTerm: string;
}

const CustomerSearchResults: React.FC<CustomerSearchResultsProps> = ({
  open,
  onClose,
  customers,
  onSelectCustomer,
  searchTerm
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ bgcolor: '#f5f5f5', p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            العملاء المطابقين لـ "{searchTerm}"
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent sx={{ p: 1 }}>
        {customers.length === 0 ? (
          <Box textAlign="center" p={3}>
            <Typography variant="body1" color="text.secondary">
              لم يتم العثور على عملاء مطابقين
            </Typography>
          </Box>
        ) : (
          <List sx={{ py: 0 }}>
            {customers.map((customer) => (
              <React.Fragment key={customer._id}>
                <ListItem 
                  button 
                  onClick={() => onSelectCustomer(customer)}
                  sx={{ 
                    py: 2, 
                    '&:hover': { bgcolor: '#f5f5f5' },
                    borderRadius: 1
                  }}
                >
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: 'primary.main' }}>
                      <PersonIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle1" fontWeight="bold">
                        {customer.name}
                      </Typography>
                    }
                    secondary={
                      <Box>
                        {customer.phone && (
                          <Typography variant="body2" component="span" sx={{ display: 'block' }}>
                            الهاتف: {customer.phone}
                          </Typography>
                        )}
                        {customer.email && (
                          <Typography variant="body2" component="span" sx={{ display: 'block' }}>
                            البريد: {customer.email}
                          </Typography>
                        )}
                      </Box>
                    }
                  />
                </ListItem>
                <Divider component="li" variant="inset" />
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CustomerSearchResults;